const layout = () => import('../../internal/dashboard/layoutV2.vue')
const colaborators = () => import('./colaborators.vue')
const myOrders = () => import('./myOrdersV2.vue')
const random = () => import('./random.vue')

const myOrdersRoutes = {
  component: layout,
  children: [
    {
      path: '/myOrders',
      name: 'myOrders',
      meta: {
        title: 'myOrders',
        requiresAuth: true,
      },
      component: myOrders,
    },
    {
      path: '/myOrders/random',
      name: 'myOrdersRandom',
      meta: {
        title: 'myOrdersRandom',
        requiresAuth: true,
      },
      component: random,
    },
    {
      path: '/colaborators/random',
      name: 'colaboratorsRandom',
      meta: {
        title: 'colaboratorsRandom',
        requiresAuth: true,
      },
      component: colaborators,
    },
  ],
}

export default myOrdersRoutes
